var map = {
	"./art-deco-1.jpg": 32306,
	"./art-deco-10.jpg": 77389,
	"./art-deco-11.jpg": 327,
	"./art-deco-2.jpg": 39687,
	"./art-deco-3.jpg": 5625,
	"./art-deco-4.jpg": 62410,
	"./art-deco-5.jpg": 47899,
	"./art-deco-6.jpg": 14272,
	"./art-deco-7.jpg": 38588,
	"./art-deco-8.jpg": 89772,
	"./art-deco-9.jpg": 33936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62079;